var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    // TODO: Remove these classes once the styles are all moved to Tailwind and we're no longer using
    // any styles from the SCSS files.
    // `wish-list-v2` means excluding this component from using styles in app/assets/stylesheets/3/surface/show/layouts/*.scss
    'wish-list-v2',
    'wish-list',

    'z-wishlist',
  ],attrs:{"id":"wish-list"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }